import React from "react";
import { connect } from "react-redux";
import authorizationStore from "../auth/authorizationStore";
import jwtUtils from "../utils/jwtUtils";
import { History } from "history";
import { LoadingSpinner } from "components/common";
import { Routes } from "../../routes";
import { RootState } from "../../redux/store";
import { EventEditionDetails } from "../types";
import NetworkHelper from "../network/helpers/network/helper/NetworkHelper";
import AuthHelper from "../auth/helpers/AuthHelper";
import { setIsAdmin } from "../../redux/metadata/slice/metadataSlice";

type Props = {
  setIsAdmin: (val: boolean) => void;
  history: History;
  eventEdition: EventEditionDetails;
  contextType: any
};

type State = {
  isLoading: boolean;
};

export const withAdminCheck = WrappedComponent => {
  class HOC extends React.Component<Props, State> {
    constructor(props) {
      super(props);
      this.state = {
        isLoading: true
      };
    }

    checkAdminRole = async () => {
      try {
        const { history, setIsAdmin, eventEdition } = this.props;
        const token = await authorizationStore.getToken();
        const isOnline = await NetworkHelper.isConnected();
        if (!token) {
          if (!isOnline) {
            setIsAdmin(true);
          }
          this.setState({ isLoading: false });
          return;
        }

        const isRxAdmin = jwtUtils.isLoggedUserRxAdmin(token);
        const isBuAdmin = jwtUtils.isLoggedUserBUAdmin(token);
        const isTempStaff = jwtUtils.isLoggerUserTempStaff(token, eventEdition.gbsCode);
        const isUserManager = jwtUtils.isLoggedUserManager(token, eventEdition.gbsCode);
        const isUserFinance = jwtUtils.isLoggedUserFinance(token, eventEdition.gbsCode);

        if (isRxAdmin || isBuAdmin || isTempStaff || isUserManager || isUserFinance) {
          this.setState({ isLoading: false });
          setIsAdmin(true);
          return;
        }

        setIsAdmin(false);
        this.setState({ isLoading: false });
        history.push(Routes.unauthorized);
      } catch (e) {
        console.error(e);
      }
    };

    componentDidMount() {
      if (AuthHelper.isWithoutAuth()) {
        this.setState({ isLoading: false });
        return;
      }
      this.checkAdminRole();
    }

    render() {
      const { isLoading } = this.state;

      if (isLoading) {
        return <LoadingSpinner />;
      }

      return <WrappedComponent />;
    }
  }

  const mapStateToProps = (state: RootState) => {
    return {
      eventEdition: state.eventEdition.eventEdition
    };
  };

  const mapDispatchToProps = dispatch => {
    return {
      setIsAdmin: (val: boolean) => dispatch(setIsAdmin(val))
    };
  };

  const ConnectedHOC = connect(mapStateToProps, mapDispatchToProps)(HOC);

  return ConnectedHOC as any;
};
